export default "__VITE_ASSET__DG2ztV9K__"